<template>
  <NuxtLink
    :aria-label="linkLabel"
    :to="link"
    :target="isExternalLink ? '_blank' : undefined"
  >
    <slot :icon="icon" />
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  link: string
  label?: string
}>()
const isExternalLink = computed(
  () => !!['http', 'tel:', 'mailto:'].some((el) => props.link?.includes(el)),
)
const linkLabel = computed(() =>
  props?.label && isExternalLink.value
    ? props.label + ' - opens in new tab'
    : props?.label,
)
// optional internal/external icon for the inline MediaImage component
const icon = computed(() =>
  isExternalLink.value
    ? 'fa6-solid:arrow-up-right-from-square'
    : 'fa6-solid:chevron-right',
)
</script>
